<template>
  <tr class="custom-sort">
    <td
      v-for="(item, index) in props.headers"
      :key="index"
      class="sort-item"
      :class="`item--${item.text ? item.text.toLowerCase() : 'select'}`"
    >
      <div
        class="custom-sort__checkbox mt-1"
        v-if="index === 0 && canBeSelected"
      >
        <checkbox :checked="allSelected" @change="handleSelectAll" />
      </div>
      <div
        v-else-if="item.text"
        class="custom-sort__item"
        :class="`${item.sortable ? 'custom-sort__item--sortable' : ''}`"
        @click="item.sortable ? handleSortClick(item) : ''"
      >
        {{ $t(`table.header.${item.text}`) }}
        <div class="custom-sort__arrows" v-if="item.sortable">
          <v-icon
            size="12"
            :up="
              !props.options.sortDesc[0] &&
              props.options.sortBy[0] === item.value
            "
            :down="
              props.options.sortDesc[0] &&
              props.options.sortBy[0] === item.value
            "
            class="custom-sort__arrow-up"
            >$arrowsSort</v-icon
          >
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import Checkbox from "../buttons/Checkbox.vue";

export default {
  components: {
    Checkbox,
  },
  props: {
    isMobile: Boolean,
    props: Object,
    allSelected: Boolean,
    canBeSelected: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleSelectAll() {
      this.$emit("selectAll", !this.allSelected);
    },
    handleSortClick: function (data) {
      if (this.props.options.sortBy[0] === data.value) {
        this.$emit("update:sortDesc", !this.props.options.sortDesc[0]);
      } else {
        this.$emit("update:sortBy", data);
      }
    },
  },
};
</script>

<style src="./TableCustomSort.scss" lang="scss" scoped />
